import { render, staticRenderFns } from "./separateVote.vue?vue&type=template&id=8350127e&scoped=true"
import script from "./separateVote.vue?vue&type=script&lang=js"
export * from "./separateVote.vue?vue&type=script&lang=js"
import style0 from "./separateVote.vue?vue&type=style&index=0&id=8350127e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8350127e",
  null
  
)

export default component.exports